import { compose, createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
// import thunk from "redux-thunk";
import { rootReducer } from "./root-reducer";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "./root-saga";


// redux-persist
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['cart'],
}


const sagaMiddleware = createSagaMiddleware();

const persistedReducder = persistReducer(persistConfig, rootReducer)

const middleWares = [process.env.NODE_ENV !== 'production' && logger, sagaMiddleware]
.filter(Boolean);

const composeEnhancer = 
(process.env.NODE_ENV !== 'production' && window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;


const composedEnhancers = composeEnhancer(applyMiddleware(...middleWares))

// by default using persistedReducder
export const store = createStore(persistedReducder, undefined, composedEnhancers);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
